angular.module('SpidApp')

.factory('Device',
        ['Scale', 'Drawer', 'StickerPrinter', 'ReceiptPrinter', '$q', 'SPID_CONFIG',
function (Scale,   Drawer,   StickerPrinter,   ReceiptPrinter,   $q,   SPID_CONFIG) {
	window.Scale = Scale
	var Device = {
		goodColorClass    : 'bg-success',
		pendingColorClass : 'bg-warning',
		badColorClass     : 'bg-danger',

		goodIconColorClass : 'good',
		badIconColorClass  : 'bad',

		scalePromise   : $q(function (r) { r() }),
		drawerPromise  : $q(function (r) { r() }),
		stickerPromise : $q(function (r) { r() }),
		receiptPromise : $q(function (r) { r() }),

		getUnionStatus : (SPID_CONFIG.devices.areMocked ? function () {
			return $q(function (resolve) {
				resolve('OK')
			})
		} : function () {
			return $q.all([this.scalePromise, this.drawerPromise, this.stickerPromise, this.receiptPromise]).then(function () {
				return 'OK'
			}, function () {
				throw 'Propagate'
			}).catch(function () {
				return 'KO'
			})
		}),

		getDevices: SPID_CONFIG.devices.areMocked ? function () {
			return {
				scale          : { name: 'Balance',             iconClass: 'glyphicon glyphicon-scale', status: { status: 'OK', colorClass: Device.goodColorClass } },
				drawer         : { name: 'Caisse',              iconClass: 'glyphicon glyphicon-euro',  status: { status: 'OK', colorClass: Device.goodColorClass } },
				stickerPrinter : { name: 'Imprimante vignette', iconClass: 'glyphicon glyphicon-print', status: { status: 'OK', colorClass: Device.goodColorClass } },
				receiptPrinter : { name: 'Imprimante ticket',   iconClass: 'glyphicon glyphicon-print', status: { status: 'OK', colorClass: Device.goodColorClass } }
			}
		} : function () {
			var devices = {
				scale          : { name: 'Balance',             iconClass: 'glyphicon glyphicon-scale', status: { stauts: null, colorClass: Device.pendingColorClass } },
				drawer         : { name: 'Caisse',              iconClass: 'glyphicon glyphicon-euro',  status: { stauts: null, colorClass: Device.pendingColorClass } },
				stickerPrinter : { name: 'Imprimante vignette', iconClass: 'glyphicon glyphicon-print', status: { stauts: null, colorClass: Device.pendingColorClass } },
				receiptPrinter : { name: 'Imprimante ticket',   iconClass: 'glyphicon glyphicon-print', status: { stauts: null, colorClass: Device.pendingColorClass } }
			}
			
			this.scalePromise = Scale.getStatus()
				.then( function () {
					devices.scale.status = { status : 'OK', colorClass : Device.goodColorClass }
				})
				.catch(function () {
					devices.scale.status = { status : 'KO', colorClass : Device.badColorClass }
					throw 'Propagate'
				})
			
			this.drawerPromise = Drawer.getStatus()
				.then( function () {
					devices.drawer.status = { status : 'OK',       colorClass : Device.goodColorClass }
				}).catch(function (error) {
					devices.drawer.status = { status : error.code, colorClass : Device.badColorClass  }
					throw 'Propagate'
				})
			
			this.stickerPromise = StickerPrinter.getStatus()
				.then( function (response) {
					var status = 'OK'
					var colorClass = Device.goodColorClass
					
					if (response) {
						if (response.code === 0) {
							status = 'OK'
						} else {
							status = response.message[0]
							colorClass = Device.badColorClass
						}
					}
				
					devices.stickerPrinter.status = { status : status,         colorClass : colorClass }
				}).catch(function () {
					devices.stickerPrinter.status = { status : 'inaccessible', colorClass : Device.badColorClass  }
					throw 'Propagate'
				})
			
			this.receiptPromise = ReceiptPrinter.getStatus()
				.then( function (response) {
					var status = 'OK'
					var colorClass = Device.goodColorClass
					
					if (response) {
						if (response.code === 0) {
							status = 'OK'
						} else {
							status = response.message[0]
							colorClass = Device.badColorClass
						}
					}
					devices.receiptPrinter.status = { status : status,         colorClass : colorClass }
				}).catch(function () {
					devices.receiptPrinter.status = { status : 'inaccessible', colorClass : Device.badColorClass  }
					throw 'Propagate'
				})

			return devices
		}
	}

	return Device
}])